import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text, Radio, RadioGroup, Stack} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'

const WarrantySelector = ({warrantyGroup, selectedVariantId, onVariantSelect}) => {
    return (
        <Box>
            <Text fontWeight="bold" fontSize="md" mb={2}>
                <FormattedMessage id="extend-warranty" defaultMessage="Extend your warranty" />
            </Text>
            <Text mb={2}>
                <FormattedMessage
                    id="warranty-selector.description"
                    defaultMessage="Scopri la tranquillità che offre l'estensione di garanzia per i tuoi elettrodomestici De'Longhi! Con questa opzione, potrai proteggere il tuo investimento e godere di un servizio assistenza dedicato, garantendo che i tuoi prodotti funzionino sempre al meglio.."
                />
            </Text>

            <RadioGroup onChange={onVariantSelect} value={selectedVariantId || ''}>
                <Stack>
                    {warrantyGroup.variants.map((variant) => (
                        <Radio key={variant.productId} value={variant.productId}>
                            <Text as="span" ml={2}>
                                {variant.variationAttributes?.duration || variant.productName} -{' '}
                                <Text as="span" fontWeight="bold">
                                    {variant.price}€
                                </Text>
                            </Text>
                        </Radio>
                    ))}
                </Stack>
            </RadioGroup>
        </Box>
    )
}

WarrantySelector.propTypes = {
    warrantyGroup: PropTypes.object.isRequired,
    parentProductId: PropTypes.string.isRequired,
    selectedVariantId: PropTypes.string,
    onVariantSelect: PropTypes.func.isRequired,
}

export default WarrantySelector
